import { ADD_PHONE_WITH_MASK } from '../actionTypes';

const initialState = {
  phoneWithMask: '',
  phone: '',
};

export default function personalReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_PHONE_WITH_MASK: {
      const { phone, unmaskedPhone } = action.payload;
      return {
        ...state,
        phoneWithMask: phone,
        phone: unmaskedPhone,
      };
    }
    default:
      return state;
  }
}
